// Core imports
import * as React from 'react';

// Components imports

// Models imports Style and misc imports
import './SelectOption.scss';

export interface ISelectOption {
  name: string;
  value: any;
}

export interface ISelectOptionProps {
  key: any;
  option: ISelectOption;
  onSelect: (selected: ISelectOption) => void;
}

export function SelectOption(props: ISelectOptionProps) {
  return (
    <div
      className="rp-select2-option"
      key={props.option.name}
      onClick={() => props.onSelect(props.option)}
    >
      {props.option.name}
    </div>
  );
}
